// https://gist.github.com/tannerlinsley/65ac1f0175d79d19762cf06650707830
export function SafeHydrate({ children }: { children: JSX.Element }) {
  return (
    <div suppressHydrationWarning={true}>
      {/*Must be a div, can't be a fragment 😑🤦‍♂️*/}
      {children}
    </div>
  );
}
